export default __webpack_public_path__ + "static/media/support-phone-icon.145b5ca9.svg";